import React, { useEffect, useState } from "react";
import { Box, Card, CardContent, Tab, Tabs, Typography } from "@mui/material";
import AddGateways from "./paymentTab";
import { colorBrandObject } from "../../../../constants/brandings";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{}}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
const AddPaymentGateways = () => {
  const [value, setValue] = useState(0);
  const [pspSelected, setPspSelected] = useState([]);
  const [payload, setPayload] = useState([]);
  const [paymentOptions, setPaymentOptions] = useState([]);
  const [paymentOptionsIds, setPaymentOptionsIds] = useState([]);
  const [storeOptions, setStoreOptions] = useState([]);
  const [storeCreds, setStoreCreds] = useState([]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (pspSelected?.length == 0) {
      sessionStorage.removeItem("SelectedPsps");
      sessionStorage.removeItem("storeCreds");
      sessionStorage.removeItem("storeOptions");
    }
    localStorage.setItem('paymentSwitchTabs', true)
  }, []);

  useEffect(() => {
    if (pspSelected?.length == 0) {
      setPaymentOptions([]);
      setPaymentOptionsIds([]);
      setStoreOptions([]);
      setStoreCreds([]);
    }
  }, [payload]);

  const [cardSelects, setCardSelects] = useState([]);
  const [walletSelects, setWalletSelects] = useState([]);
  const [bnplSelects, setBnplSelects] = useState([]);
  const [NetBankingSelects, setNetBankingSelects] = useState([]);
  const [upiSelects, setUpiSelects] = useState([]);
  const [cryptoSelects, setCryptoSelects] = useState([]);
  const [PaynowSelects, setPaynowSelects] = useState([]);
  const [supportedOptions, setSupportedOptions] = useState([]);
  const [emiSelects, setEmiSelects] = useState([]);

  const [countCards, setCountCards] = useState(0);
  const [countWallet, setCountWallet] = useState(0);
  const [countNetBanking, setCountNetBanking] = useState(0);
  const [countBNPL, setCountBNPL] = useState(0);
  const [countUPI, setCountUPI] = useState(0);
  const [countCrypto, setCountCrypto] = useState(0);
  const [countPaynow, setCountPaynow] = useState(0);
  const [countEMI, setCountEMI] = useState(0);
  const [toggleTabs, setToggleTabs] = useState(true);

  useEffect(() => {

    const handleBeforeUnload = (event) => {
      if (event) {
        event.preventDefault()
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const toggleStatus = localStorage.getItem('paymentSwitchTabs');
  useEffect(() => {
    toggleStatus !== null && setToggleTabs(toggleStatus === "true");
  }, [toggleStatus]);

  return (
    <>
      <div className="content-wrapper" style={{ background: "white" }}>
        <Card sx={{ minWidth: 275, height: "80vh", boxShadow: "none" }}>
          <CardContent sx={{ marginBottom: "-30px" }}>
            <Box
              sx={{
                borderBottom: 1,
                borderColor: "divider",
                width: "410px",
              }}
            >
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
                TabIndicatorProps={{
                  sx: {
                    background: colorBrandObject?.primaryButtonColor,
                    height: 2,
                  },
                }}
              >
                <Tab
                  sx={{
                    fontFamily: "Poppins",
                    fontSize: "16px",
                    fontWeight: 600,
                    textTransform: "none",
                    color: `${colorBrandObject?.primaryButtonColor} !important`
                  }}
                  label="Payment Gateways"
                />
                <Tab
                  sx={{
                    fontFamily: "Poppins",
                    fontSize: "16px",
                    fontWeight: 600,
                    textTransform: "none",
                    color: `${colorBrandObject?.primaryButtonColor} !important`
                  }}
                  label="Payment Options"
                  disabled={toggleTabs}
                />
              </Tabs>
            </Box>

            <TabPanel value={value} index={0}>
              <AddGateways
                value={value}
                setValue={setValue}
                pspSelected={pspSelected}
                setPspSelected={setPspSelected}
                payload={payload}
                setPayload={setPayload}
                storeCreds={storeCreds}
                setStoreCreds={setStoreCreds}
                cardSelects={cardSelects}
                setCardSelects={setCardSelects}
                walletSelects={walletSelects}
                setWalletSelects={setWalletSelects}
                bnplSelects={bnplSelects}
                setBnplSelects={setBnplSelects}
                NetBankingSelects={NetBankingSelects}
                setNetBankingSelects={setNetBankingSelects}
                upiSelects={upiSelects}
                setUpiSelects={setUpiSelects}
                emiSelects={emiSelects}
                setEmiSelects={setEmiSelects}
                cryptoSelects={cryptoSelects}
                setCryptoSelects={setCryptoSelects}
                PaynowSelects={PaynowSelects}
                setPaynowSelects={setPaynowSelects}
                paymentOptions={paymentOptions}
                setPaymentOptions={setPaymentOptions}
                supportedOptions={supportedOptions}
                setSupportedOptions={setSupportedOptions}
                paymentOptionsIds={paymentOptionsIds}
                setPaymentOptionsIds={setPaymentOptionsIds}
                countCards={countCards}
                setCountCards={setCountCards}
                countWallet={countWallet}
                setCountWallet={setCountWallet}
                countBNPL={countBNPL}
                setCountBNPL={setCountBNPL}
                countNetBanking={countNetBanking}
                setCountNetBanking={setCountNetBanking}
                countUPI={countUPI}
                setCountUPI={setCountUPI}
                countEMI={countEMI}
                setCountEMI={setCountEMI}
                countCrypto={countCrypto}
                setCountCrypto={setCountCrypto}
                countPaynow={countPaynow}
                setCountPaynow={setCountPaynow}
              />
            </TabPanel>

            <TabPanel value={value} index={1}>
              <AddGateways
                value={value}
                setValue={setValue}
                pspSelected={pspSelected}
                setPspSelected={setPspSelected}
                payload={payload}
                setPayload={setPayload}
                paymentOptions={paymentOptions}
                setPaymentOptions={setPaymentOptions}
                paymentOptionsIds={paymentOptionsIds}
                setPaymentOptionsIds={setPaymentOptionsIds}
                storeOptions={storeOptions}
                setStoreOptions={setStoreOptions}
                supportedOptions={supportedOptions}
                setSupportedOptions={setSupportedOptions}
              />
            </TabPanel>
          </CardContent>
        </Card>
      </div>
    </>
  );
};

export default AddPaymentGateways;
